import { GUID } from "../../../helpers/guid.helper";

export class ChangeCourseStudentDto {
    Id: string;
    DivisionId: number;
    SchoolYearId: number;
    
    constructor() {
        this.Id = GUID.newGuid();
        this.DivisionId = -1;
        this.SchoolYearId = undefined;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/students/dto/ChangeCourseStudentDto.ts